import { type SupportArticle } from "./types";

interface SupportArticleData {
  data?: SupportArticle[];
}

export function findSupportArticleUrlById(
  supportArticlesData: SupportArticleData | undefined,
  articleId: string
): string | undefined {
  return supportArticlesData?.data?.find((article) => article.id === articleId)?.attributes
    .distributionUrl;
}
